var exports = {
  "z": "styledGroupHeaderWrapper__Lmnk_4",
};

module.exports = exports;
